import * as types from "./types"

const initialState = {
    globalConfigData: {},
}

export default function configReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_GLOBAL_CONFIG_DATA: {
            return {
                ...state,
                globalConfigData: action.payload,
            }
        }
        default:
            return state
    }
}
